export default "__VITE_ASSET__CqFLArD$__"